import { object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { dateRangeValidationSchema } from '~/utils/validate';

const validateSchema = object().shape({
  ...dateRangeValidationSchema,
});

export default yupResolver(validateSchema);
